import React, { FC, useRef, useState } from 'react';
import { useQuery } from '@apollo/client/react';
import './Invoices.scss';
import 'material-design-icons/iconfont/material-icons.css';
import { Error, Loading } from '../_common';
import InvoicesHeader from '../Header/InvoicesHeader';
import { InvoicesFilters } from '../Filter/InvoicesFilter';
import { useStoreContext } from '../App/StoreProvider';

import Paper from '@mui/material/Paper';
import {
    SortingState,
    SelectionState,
    IntegratedSelection,
    PagingState,
    CustomPaging,
} from '@devexpress/dx-react-grid';
import {
    Grid,
    DragDropProvider,
    Table,
    TableHeaderRow,
    TableColumnReordering,
    TableSelection,
    PagingPanel,
    TableColumnResizing,
    TableColumnVisibility,
} from '@devexpress/dx-react-grid-material-ui';
import { alpha, styled } from '@mui/material';
import { GetInvoiceList_getInvoiceList as Invoice, GetInvoiceList } from '../../types/schemaTypes';
import { GET_ALL_INVOICE_LIST } from '../../graphql/client/queries';

const _PAGE_SIZE = 50;

const PREFIX = 'Demo';

const classes = {
    tableStriped: `${PREFIX}-tableStriped`,
};
const $grey = '#333';
const StyledTable = styled(Table.Table)(({ theme: _theme }) => ({
    [`&.${classes.tableStriped}`]: {
        '& tbody tr:nth-of-type(odd)': {
            backgroundColor: alpha($grey, 0.015),
        },
    },
}));

const TableComponent = props => <StyledTable {...props} className={classes.tableStriped} />;
const Invoices: FC = (): React.JSX.Element => {
    // TODO: Move local state to jobListReducer
    const [state, _dispatch] = useStoreContext();
    const {
        invoice: { searchString, fromDate, toDate, addressNumber, invoiceStatus, poNumber, invoiceNumber },
        customerList: { customer },
    } = state;
    const [_listHeight, setListHeight] = useState(window.screen.height);
    const abortController = new AbortController();
    let currentOffSet = 0;

    const [columns] = useState([
        { name: 'invoiceNo', title: 'Invoice Number' },
        { name: 'poNumber', title: 'PO Number' },
        { name: 'shipName', title: 'Ship Name' },
        { name: 'shipCity', title: 'Ship City' },
        { name: 'invoiceDate', title: 'Invoice Date' },
        { name: 'netDueDate', title: 'Net Due Date' },
        { name: 'closedDate', title: 'Closed Date' },
        { name: 'pastDueDays', title: 'Past Due Days' },
        { name: 'grossAmount', title: 'Gross Amount' },
        { name: 'openAmount', title: 'Open Amount' },
        { name: 'invoiceType', title: 'Invoice Type' },
        { name: 'taxAmount', title: 'Tax' },
    ]);

    const [columnOrder, setColumnOrder] = useState([
        'invoiceType',
        'invoiceDate',
        'netDueDate',
        'closedDate',
        'pastDueDays',
        'invoiceNo',
        'poNumber',
        'shipName',
        'shipCity',
        'taxAmount',
        'grossAmount',
        'openAmount',
    ]);
    const [defaultColumnWidths] = useState([
        { columnName: 'invoiceNo', width: 180 },
        { columnName: 'poNumber', width: 180 },
        { columnName: 'shipName', width: 180 },
        { columnName: 'shipCity', width: 180 },
        { columnName: 'invoiceDate', width: 180 },
        { columnName: 'netDueDate', width: 180 },
        { columnName: 'closedDate', width: 180 },
        { columnName: 'pastDueDays', width: 180 },
        { columnName: 'grossAmount', width: 180 },
        { columnName: 'openAmount', width: 180 },
        { columnName: 'invoiceType', width: 180 },
        { columnName: 'taxAmount', width: 180 },
    ]);

    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [pageSizes] = useState([10, 20, 30, 50]);
    const currentFilters = useRef({});
    const invoiceData = useRef({});
    const [selection, setSelection] = React.useState<Array<number | string>>([]);
    const [sorting, setSorting] = useState([{ columnName: 'invoiceDate', direction: 'desc' }]);
    const abortRequest = (): void => {
        abortController.abort();
    };

    const setListContainerHeight = (): void => {
        const filterDiv = document.getElementById('InvoicesContainer');
        const listDiv = document.getElementById('InvoicesContainer');

        let filterHeight = 0;
        // setTimeout in place to avoid animation miscalculations
        setTimeout(() => {
            if (filterDiv) {
                filterHeight = filterDiv.scrollHeight;
            }
            if (listDiv) {
                setListHeight(Math.min(filterHeight));
            }
        }, 100);
    };
    currentOffSet = currentPage;
    if (
        currentFilters &&
        (currentFilters.current['searchString'] !== searchString ||
            currentFilters.current['fromDate'] !== fromDate ||
            currentFilters.current['toDate'] !== toDate ||
            currentFilters.current['customer'] !== customer ||
            currentFilters.current['addressNumber'] !== addressNumber ||
            currentFilters.current['invoiceStatus'] !== invoiceStatus ||
            currentFilters.current['poNumber'] !== poNumber ||
            currentFilters.current['invoiceNumber'] !== invoiceNumber)
    ) {
        currentOffSet = 0;
        setCurrentPage(0);
        setSelection([]);
    }

    document.title = 'My Invoices';
    const variables = {
        input: {
            searchString,
            customer,
            fromDate,
            toDate,
            addressNumber,
            invoiceStatus,
            pageSize,
            offSet: currentOffSet,
            sortParam: sorting[0].columnName,
            sortDirection: sorting[0].direction,
            invoiceNumber,
            poNumber,
        },
    };

    currentFilters.current = {
        searchString,
        customer,
        fromDate,
        toDate,
        addressNumber,
        invoiceStatus,
        invoiceNumber,
        poNumber,
    };
    console.log('variables', variables, 'currentPage', currentPage, 'pageSize', pageSize);

    const onDownloadInvoice = () => {
        console.log('onDownloadBol - selection', selection);
        if (selection.length > 0) {
            let invoiceNos = '';
            selection.forEach(element => {
                invoiceNos =
                    invoiceNos === ''
                        ? invoiceData.current[element].invoiceNo
                        : invoiceNos + ',' + invoiceData.current[element].invoiceNo;
            });
            console.log('onDownloadBol - invoiceNos', invoiceNos);
            const queryparams = `?invoiceNo=${invoiceNos}`;
            window.open(`${import.meta.env.VITE_API_URL}Invoice/DownloadInvoice${queryparams}`, '_blank');
        }
    };

    const onPrintInvoice = () => {
        console.log('onPrintBol - selection', selection);
        console.log('onDownloadBol - selection', selection);
        if (selection.length > 0) {
            let invoiceNos = '';
            selection.forEach(element => {
                invoiceNos =
                    invoiceNos === ''
                        ? invoiceData.current[element].invoiceNo
                        : invoiceNos + ',' + invoiceData.current[element].invoiceNo;
            });
            console.log('onDownloadBol - invoiceNos', invoiceNos);
            const queryparams = `?invoiceNo=${invoiceNos}`;
            window.open(`${import.meta.env.VITE_API_URL}Invoice/PrintInvoice${queryparams}`, '_blank');
        }
    };

    const onPageNumberChanges = count => {
        setSelection([]);
        setCurrentPage(0);
        setPageSize(count);
        console.log('onPageNumberChanges', count);
    };

    const onPageChanges = count => {
        setSelection([]);
        setCurrentPage(count);
        console.log('onPageChanges', count);
    };

    const Cell = (props: any) => {
        const { column, row, tablerow: _tablerow }: any = props;
        if (column.name === 'grossAmount') {
            const value = row.grossAmount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            return (
                <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeMedium TableCell-cell TableCell-cellNoWrap base-genricCss ">
                    ${value}
                </td>
            );
        }
        if (column.name === 'openAmount') {
            const value = row.openAmount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            return (
                <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeMedium TableCell-cell TableCell-cellNoWrap base-genricCss">
                    ${value}
                </td>
            );
        }
        if (column.name === 'taxAmount') {
            const value = row.taxAmount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            return (
                <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeMedium TableCell-cell TableCell-cellNoWrap base-genricCss">
                    ${value}
                </td>
            );
        }
        return <Table.Cell {...props} />;
    };

    const { error, data, loading } = useQuery<GetInvoiceList>(GET_ALL_INVOICE_LIST, {
        variables,
        skip: !customer || customer === 0,
        fetchPolicy: 'network-only',
    });
    const invoiceList: Invoice[] = [];
    let totalRowsCount = 0;
    if (data?.getInvoiceList?.length) {
        data.getInvoiceList.forEach((element: Invoice | null): void => {
            if (element !== null) {
                totalRowsCount = Number(element.totalRecordsCount);
                invoiceList.push(element);
            }
        });
        console.log('invoiceList', invoiceList);
        invoiceData.current = invoiceList;
    }

    if (customer && customer !== 0) {
        return (
            <div className="Invoices-Container">
                {error && <Error error={error} />}
                <InvoicesHeader onDownloadInvoices={onDownloadInvoice} onPrintInvoices={onPrintInvoice} />
                <div id="BodyGrid" className="Invoices-Body row">
                    <InvoicesFilters abortRequest={abortRequest} onFilterToggle={setListContainerHeight} />
                    <div id="GridContainer" className="pl-0 col-md-9 Invoices-List">
                        <div className="InvoicesList">
                            <div className="JonItem-Container">
                                {loading && (
                                    <div className="SpinnerContainer">
                                        <Loading />
                                    </div>
                                )}
                                <Paper>
                                    <Grid rows={invoiceList} columns={columns}>
                                        <SelectionState
                                            selection={selection}
                                            onSelectionChange={setSelection}
                                        />
                                        <IntegratedSelection />
                                        <DragDropProvider />
                                        <SortingState onSortingChange={setSorting} />
                                        <PagingState
                                            currentPage={currentPage}
                                            onCurrentPageChange={onPageChanges}
                                            pageSize={pageSize}
                                            onPageSizeChange={onPageNumberChanges}
                                        />
                                        <CustomPaging totalCount={totalRowsCount} />
                                        <Table tableComponent={TableComponent} cellComponent={Cell} />
                                        <TableColumnResizing defaultColumnWidths={defaultColumnWidths} />
                                        <TableHeaderRow showSortingControls />
                                        <TableColumnReordering
                                            order={columnOrder}
                                            onOrderChange={setColumnOrder}
                                        />
                                        <TableSelection showSelectAll />
                                        <TableColumnVisibility />
                                        <PagingPanel pageSizes={pageSizes} />
                                    </Grid>
                                </Paper>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className="Invoices-Container">
                <InvoicesHeader onDownloadInvoices={onDownloadInvoice} onPrintInvoices={onPrintInvoice} />
                <div id="BodyGrid" className="Invoices-Body row">
                    <InvoicesFilters abortRequest={abortRequest} onFilterToggle={setListContainerHeight} />
                    <div id="GridContainer" className="pl-0 col-md-9 Invoices-List">
                        <div className="InvoicesList">
                            <div className="JonItem-Container">
                                <Paper>
                                    <Grid rows={[]} columns={columns}>
                                        <PagingState
                                            currentPage={currentPage}
                                            onCurrentPageChange={setCurrentPage}
                                            pageSize={pageSize}
                                            onPageSizeChange={setPageSize}
                                        />
                                        <SelectionState selection={selection} onSelectionChange={setSelection} />
                                        <IntegratedSelection />
                                        <SortingState defaultSorting={[{ columnName: 'ponumber', direction: 'asc' }]} />
                                        <DragDropProvider />
                                        <CustomPaging totalCount={0} />
                                        <Table tableComponent={TableComponent} />
                                        <TableColumnResizing defaultColumnWidths={defaultColumnWidths} />
                                        <TableHeaderRow showSortingControls />
                                        <TableColumnReordering order={columnOrder} onOrderChange={setColumnOrder} />
                                        <TableSelection showSelectAll />
                                        <TableColumnVisibility />
                                        <PagingPanel pageSizes={pageSizes} />
                                    </Grid>
                                </Paper>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default Invoices;
